/** The subset of Mercado Pago's browser SDK that the card form uses. */
export type CardFormData = {
  token: string;
  issuer_id?: string;
  payment_method_id: string;
  installments?: number;
};

type BrickController = { unmount: () => void };

type MercadoPagoSdk = new (
  publicKey: string,
  options: { locale: string },
) => {
  bricks: () => {
    create: (
      brick: "cardPayment",
      containerId: string,
      settings: {
        initialization: { amount: number };
        customization?: { paymentMethods?: { maxInstallments?: number } };
        callbacks: {
          onReady?: () => void;
          onSubmit: (data: CardFormData) => Promise<void>;
          onError?: (error: unknown) => void;
        };
      },
    ) => Promise<BrickController>;
  };
};

declare global {
  interface Window {
    MercadoPago?: MercadoPagoSdk;
  }
}

const SDK_URL = "https://sdk.mercadopago.com/js/v2";
let loading: Promise<MercadoPagoSdk> | null = null;

/** Loads the provider's own script the first time a card form is shown, and never otherwise. */
export function loadMercadoPago(): Promise<MercadoPagoSdk> {
  if (window.MercadoPago) return Promise.resolve(window.MercadoPago);
  loading ??= new Promise<MercadoPagoSdk>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = SDK_URL;
    script.async = true;
    script.onload = () => {
      if (window.MercadoPago) resolve(window.MercadoPago);
      else reject(new Error("Card form unavailable"));
    };
    script.onerror = () => reject(new Error("Card form unavailable"));
    document.head.append(script);
  }).catch((error: unknown) => {
    loading = null;
    throw error;
  });
  return loading;
}
